import { gql } from '@urql/core';
import React from 'react';
import { SocialCardData, SocialCard } from './SocialCard';
import { NotificationsCardFragment } from '../../../../generated/spin-graphql';
import { useAppState } from '../../../../client/providers/AppProvider';

type Props = {
    conversationStarted: NotificationsCardFragment;
    viewedAt: any;
};

gql`
    fragment ConversationStartedCard on espin_notification {
        college {
            name
            slug
            logo {
                ...SpinContentImageDisplay
            }
        }
    }
`;

export const ConversationStartedMessageCard: React.FC<Props> = ({ conversationStarted, viewedAt }) => {
    const { subscribed } = useAppState();

    const collegeName = conversationStarted?.college?.name;
    const playerName = `${conversationStarted?.player_user?.player_profile?.first_name} ${conversationStarted?.player_user?.player_profile?.last_name}`;
    const profileImg = subscribed ? conversationStarted?.college?.logo : null;
    const slug = `dashboard/messages/?college_slug=${conversationStarted?.college?.slug}`;

    const data: SocialCardData = {
        label: 'Conversation Started',
        subLabel: `A new conversation has started between ${playerName} and ${collegeName}.`,
        picAltText: `${collegeName}'s picture`,
        profileImg,
        slug,
        unread: !viewedAt,
        deletedUser: false,
    };

    return (
        <>
            <SocialCard data={data} />
        </>
    );
};
